module.exports = __webpack_public_path__ + "media/images/static/interview/interview_2-89c820195cc05c25bcf8cdc1ce169575.png";